import { environment } from 'environments/environment'

/**
 * Load the source for ClarityOps Visualizer WebComponent, which is used in the ClarityOps panel
 *
 * @param document - the DOM document, injected rather than pulled via Angular just to keep this code vanilla
 */
export function loadClarityOpsVisualizerScript(document: Document) {
  const now = Date.now()
  const jsPath = environment.externalComponents.clarityOpsVisualizer
  const script = document.getElementById('clarityOpsVisualizerUrl')
  script?.setAttribute('src', `${jsPath}?v=${now}`)
}
